<template>
    <div v-if="showBulkActions" class="main-panel index-table-bulk-actions">
        <md-card>
            <md-card-content>
                <div class="selected-items-counter" v-text="displaySelectedItemsCounter"></div>
                <div class="bulk-actions">
                    <slot/>
                    <md-icon class="bulk-actions-clear" @click.native="clearSelectedItems">clear</md-icon>
                </div>
            </md-card-content>
        </md-card>
    </div>
</template>

<script>
    import {mapGetters, mapMutations} from "vuex";

    export default {
        name: "IndexTableBulkActions",
        computed: {
            showBulkActions() {
                return this.selectedItemsCounter > 0;
            },
            displaySelectedItemsCounter() {
                return this.selectedItemsCounter + ' selected item(s)';
            },
            selectedItemsCounter() {
                return this.selectedItems.length;
            },
            ...mapGetters('indexTable', {
                selectedItems: 'getSelectedItems',
            }),
        },
        methods: {
            ...mapMutations('indexTable', {
                clearSelectedItems: 'clearSelectedItems',
            })
        }
    }
</script>

<style lang="scss" scoped>
    .index-table-bulk-actions {
        position: fixed;
        right: 0;
        bottom: 15px;
        padding: 0 45px;
        background-color: transparent;
        animation: show-bulk-actions 200ms;

        .md-card {
            margin: 0;
            padding: 0;

            .md-card-content {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
        }

        .bulk-actions {
            display: flex;
            align-items: center;

            .bulk-actions-clear {
                margin-left: 12px;
                font-size: 16px !important;
                opacity: .5;
                cursor: pointer;

                &:hover {
                    opacity: 1;
                }
            }
        }
    }

    @keyframes show-bulk-actions {
        from {
            transform: translateY(100%);
        }
        to {
            transform: translateY(0);
        }
    }
</style>